// ignore-string-externalization
import React, { useState, useEffect, useContext } from 'react';
import { Resolver } from '@spotify-internal/remote-config-resolver';
import { transport } from '@mrkt/features/transport';
import properties from './properties';
import { Context } from './hooks';

type Props = { children: React.ReactNode };

export function RemoteConfig({ children }: Props) {
  // use the default context as initial state
  const [config, setConfig] = useState(useContext(Context));

  useEffect(() => {
    // https://backstage.spotify.net/docs/remote-configuration-js-sdk/getting-started/#step-4-initializing-the-sdk
    const resolver = new Resolver({
      clientId: 'mrkt-web',
      transport,
      properties,
      timeout: 20000,
      // only applies when there isnt anything in the cache
      // potential place where app could slow down
    });

    // see: https://nodejs.org/api/events.html#events_emitter_setmaxlisteners_n
    // this PR sees 79 usages of useRemoteProperty, so this value needs to be
    // higher than that, but not so high as to hide an actual possible memory leak
    resolver.setMaxListeners(100);

    transport
      .request('https://api.spotify.com/v1/me', {
        responseType: 'json',
        authorize: true,
      })
      .then(async ({ body: { id: userKey } }) => {
        // Provide some opaque string that stays constant across user sessions (for instance username)
        await resolver.resolve({ userKey });
        // update context with active resolver once ready
        setConfig(resolver);
      });
  }, []);

  return <Context.Provider value={config}>{children}</Context.Provider>;
}
